module.exports = __webpack_public_path__ + "media/newstyle/images/after-01-32df551abf9192fc2851e1b55df04d06.png";